import { connect } from "react-redux";

import { withExternalMountingEventReporting } from "../../../Services/ExternalMountingEventReporting/withExternalMountingEventReporting";
import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { AbsoluteResolvedModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { ViewModelSelect } from "../../../../Helpers/StateAccessors/ViewModelSelect";
import { withViewModelSelect } from "../../../withViewModelSelect";
import { UnitLabelPath } from "../../../../../../Common/PathConstants";
import { withLoadedAttachmentProvider } from "../LoadedAttachmentContext";

import { MultipleUnit } from "./MultipleUnit";

interface MultipleUnitContainerProps {
    bindingPath: AbsoluteResolvedModelPath;
    index: number;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: MultipleUnitContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;

    return {
        label: viewModelSelect.controlModel(
            state,
            bindingPath.joinWith(ownProps.index.toString()).joinWith(UnitLabelPath)
        ).value,
        isReadOnly: state.settings.isReadOnly,
    };
};

export const MultipleUnitContainer = withLoadedAttachmentProvider(
    withExternalMountingEventReporting(withViewModelSelect(connect(mapStateToProps)(MultipleUnit)))
);
